export default {
	methods: {
		server (response) {
			if (response.data.notifications) {
				response.data.notifications.forEach(n => {
					this.$Message[n.type](n.text)
				})
			}
		}
	}
}



// WEBPACK FOOTER //
// ./src/mixins/server.js